module.exports = __webpack_public_path__ + "static/media/NWPG logo.1a38b352.png";